import React, { useEffect } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { t } from 'i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { HiPlus } from 'react-icons/hi';
import BackButton from '../../../components/BackButton';
import VisitDetails from './visit-details';
import VisitHeader from './visit-header';
import { useDispatch, useSelector } from 'react-redux';
import { getTodaysVisits } from '../../../redux/visit';

const Visits = () => {
	const { todaysVisits } = useSelector(state => state.visits);
	const { id } = useParams();
	const dispatch = useDispatch();
	const router = useNavigate();

	useEffect(() => {
		dispatch(getTodaysVisits({ pId: id, type: 'today', page: 1, per_page: 10 }));
	}, []);

	return (
		<Container className='mt-4'>
			<Row>
				<Col className='d-flex justify-content-between'>
					<h5 className='text-primary'>
						{t('VISIT.TITLE')}
					</h5>
					<div className='d-flex gap-2'>
						<Link className='btn btn-success btn-sm' to='add'>
							<HiPlus /> {t('VISIT.ADD_BUTTON')}
						</Link>
						<BackButton onBack={() => {
							router('/patients');
						}} />
					</div>
				</Col>
			</Row>
			<hr />
			{todaysVisits.length > 0 ? (
				todaysVisits.map((visit) => (
					<Row className='mt-4' key={visit.id}>
						<Col>
							<Card text='dark' bg='white'>
								<VisitHeader visitId={visit.id} />
								<VisitDetails visit={visit} />
							</Card>
						</Col>
					</Row>
				))
			) : (
				<Row className='mt-4'>
					<Col>
						<Card text='dark' bg='white'>
							<h5 className='text-center m-3'>{t('VISIT.NO_VISITS')}</h5>
						</Card>
					</Col>
				</Row>
			)}
		</Container>
	);
};

export default Visits;

